export default[
    {
        path: '/dataList/memberDataAlert',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '会员预警',
            authLogin: true
        }
    }
]